



















import { Component, Vue } from "vue-property-decorator";

import { Plant, Plants } from "@/types";
import { className } from "@/utilities";

import PlantBackground from "@/components/PlantBackground.vue";
import PlantGroup from "@/components/PlantGroup.vue";

@Component({
  components: {
    PlantGroup,
    PlantBackground,
  },
})
export default class PlantTypeView extends Vue {
  get type() {
    return this.$route.params.type;
  }

  get types() {
    return this.$store.state.plantTypes;
  }

  get typeClassName() {
    return className(this.type);
  }

  get plants() {
    return (this.$store.getters.getPlantsByType(this.type) as [
      number,
      Plant
    ][]).map(([number, plant]) => ({
      ...plant,
      number,
      link: `/planten/${this.type}/${number}`,
    }));
  }
}
